import { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import { useAuth } from '../../../auth';
import { useAppSelector } from '../../../../../redux/hooks';
import { ViewModalUpdate } from './Components.tsx/ViewModalUpdate';

const API_URL = process.env.REACT_APP_API_URL;

type ID = undefined | null | number;

function UsersCrud() {
    const { currentUser } = useAuth();
    const tenant = useAppSelector((state) => state.TenantSlice.id);

    const [ID, setID] = useState<ID>(undefined);
    const [records, setRecords] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [mfaActive, setMfaActive] = useState<boolean>(false);
    const [ssoActive, setSsoActive] = useState<boolean>(false);
    const [currentPage, setCurrentPage] = useState(1);
    const usersPerPage = 10;

    useEffect(() => {
        fetchUsers();
        fetchMFAStatus();
    }, [tenant]);

    // Función para obtener la lista de usuarios
    const fetchUsers = () => {
        setLoading(true);
        const endpoint =
            tenant === 0
                ? `${API_URL}/v1/auth0/users/list/`
                : `${API_URL}/v1/auth0/users/list/?tenantId=${tenant}`;

        axios
            .get(endpoint)
            .then((res) => {
                setRecords(res.data.users);
                setSsoActive(res.data.sso_active); // Set sso_active from response
            })
            .catch((err) => console.error(err))
            .finally(() => setLoading(false));
    };

    // Nueva función para obtener el estado de MFA
    const fetchMFAStatus = () => {
        axios
            .get(`${API_URL}/v1/auth0/mfa-active`)
            .then((res) => {
                setMfaActive(res.data.mfa_active);
                console.log('MFA Active Status:', res.data.mfa_active);
            })
            .catch((err) => {
                console.error('Error fetching MFA status:', err);
            });
    };

    const indexOfLastUser = currentPage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    const currentUsers = records.slice(indexOfFirstUser, indexOfLastUser);
    const paginate = (pageNumber: number) => setCurrentPage(pageNumber);
    const totalPages = Math.ceil(records.length / usersPerPage);

    return (
        <>
            <div className='card' style={{ overflow: 'visible' }}>
                <div className='card-header border-0 pt-5 '>
                    <h3 className='card-title align-items-start flex-column '>
                        <span className='f-titulo text-marino fs-md'>Users Management</span>
                    </h3>
                    <div className='card-toolbar'>
                        {currentUser?.ListPermiso?.includes('User.Create') && (
                            <>
                                {/* <button
                                    onClick={() => handleToggleMFA((currentUser.Tenant as any).OrgID)}
                                    className='btn-light-marino f-parrafo ms-2' style={{ marginRight: '10px' }}>

                                    {mfaActive ? "Disable MFA" : "Enable MFA"}
                                </button> */}
                                <button
                                    onClick={() => setID(null)}
                                    className='btn-light-marino f-parrafo'
                                    disabled={ssoActive}
                                    title={
                                        ssoActive
                                            ? 'User addition is disabled because SSO is active. Please use the configured Identity Provider (IdP) to manage user accounts.'
                                            : ''
                                    }
                                >
                                    Add +
                                </button>
                            </>
                        )}
                    </div>
                </div>

                <div className='card-body py-3' style={{ overflow: 'visible' }}>
                    {/* <p>MFA Status: {mfaActive ? "Active" : "Inactive"}</p> */}
                    {loading ? (
                        <p style={{ textAlign: 'center' }}>Loading...</p>
                    ) : (
                        <div className='tab-content'>
                            <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                                <div className='table-responsive' style={{ overflow: 'visible' }}>
                                    <table className='w-full f-parrafo caption-bottom custom-table' id='table'>
                                        <thead className='text-azul text-left'>
                                            <tr>
                                                <th className='table-cell'>Full Name</th>
                                                <th className='table-cell'>Email</th>
                                                {!ssoActive && (
                                                    <th className='table-cell'>MFA</th>
                                                )}
                                                <th className='table-cell'>Status</th>
                                                <th className='table-cell'>Role</th>
                                                <th className='table-cell'>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentUsers.length === 0 ? (
                                                <tr>
                                                    <td
                                                        colSpan={6}
                                                        style={{ textAlign: 'center', color: 'gray', padding: '20px' }}
                                                    >
                                                        No Data Available
                                                    </td>
                                                </tr>
                                            ) : (
                                                currentUsers.map((d: any, i: any) => (
                                                    <tr key={i} className='table-row'>
                                                        <td className='table-cell fw-bolder'>{d.name}</td>
                                                        <td className='table-cell'>{d.email}</td>
                                                        {!ssoActive && (
                                                            <td className='table-cell'>
                                                                <span
                                                                    className={`badge ${d.hasMFA ? 'bg-success' : 'bg-secondary'}`}
                                                                    style={{
                                                                        padding: '5px 10px',
                                                                        borderRadius: '15px',
                                                                        color: 'white',
                                                                        fontWeight: 'bold',
                                                                    }}
                                                                >
                                                                    {d.hasMFA ? 'Configured' : 'Not Configured'}
                                                                </span>
                                                            </td>
                                                        )}
                                                        <td className='table-cell'>
                                                            <span
                                                                className={`badge ${d.blocked ? 'bg-danger' : 'bg-success'}`}
                                                                style={{
                                                                    padding: '5px 10px',
                                                                    borderRadius: '15px',
                                                                    color: 'white',
                                                                    fontWeight: 'bold',
                                                                }}
                                                            >
                                                                {d.blocked ? 'Blocked' : 'Active'}
                                                            </span>
                                                        </td>
                                                        {Array.isArray(d.roles) && d.roles.length !== 0 ? (
                                                            <td className='table-cell'>
                                                                {d.roles.map((n: any, i: any) => (
                                                                    <span key={i} className='badge me-1'>
                                                                        {n.name}
                                                                    </span>
                                                                ))}
                                                            </td>
                                                        ) : (
                                                            <td className='table-cell'>No Roles</td>
                                                        )}
                                                        <td
                                                            className='table-cell'
                                                            style={{ position: 'relative', overflow: 'visible' }}
                                                        >
                                                            <div className='dropdown'>
                                                                <a
                                                                    href='#'
                                                                    className='btn btn-light btn-active-light-primary btn-sm dropdown-toggle'
                                                                    data-bs-toggle='dropdown'
                                                                    aria-expanded='false'
                                                                >
                                                                    Actions
                                                                </a>
                                                                <ul
                                                                    className='dropdown-menu dropdown-menu-end'
                                                                    style={{
                                                                        zIndex: 1050,
                                                                    }}
                                                                >
                                                                    {currentUser?.ListPermiso?.includes('User.Update') && (
                                                                        <li>
                                                                            <button
                                                                                className='dropdown-item'
                                                                                onClick={() => setID(d.user_id)}
                                                                            >
                                                                                Edit
                                                                            </button>
                                                                        </li>
                                                                    )}
                                                                    {currentUser?.ListPermiso?.includes('User.Delete') && (
                                                                        <li>
                                                                            <button
                                                                                className='dropdown-item'
                                                                                onClick={() => handleSubmit(d.user_id)}
                                                                            >
                                                                                Delete
                                                                            </button>
                                                                        </li>
                                                                    )}
                                                                    {currentUser?.ListPermiso?.includes('User.Update') && (
                                                                        <>
                                                                            <li>
                                                                                <button
                                                                                    className='dropdown-item'
                                                                                    onClick={() =>
                                                                                        toggleBlockStatus(d.user_id, d.blocked)
                                                                                    }
                                                                                >
                                                                                    {d.blocked ? 'Unblock' : 'Block'}
                                                                                </button>
                                                                            </li>
                                                                            <li>
                                                                                <button
                                                                                    className='dropdown-item'
                                                                                    onClick={() => resetPassword(d.email)}
                                                                                >
                                                                                    Reset Password
                                                                                </button>
                                                                            </li>
                                                                            {!ssoActive && (
                                                                                <li>
                                                                                    <button
                                                                                        className='dropdown-item'
                                                                                        onClick={() => resetMFA(d.user_id)}
                                                                                    >
                                                                                        Reset MFA
                                                                                    </button>
                                                                                </li>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </ul>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>

                                    <div className='pagination-container d-flex justify-content-end mt-3'>
                                        {[...Array(totalPages)].map((_, i) => (
                                            <button
                                                key={i + 1}
                                                onClick={() => paginate(i + 1)}
                                                className={`page-item btn btn-sm mx-1 ${
                                                    currentPage === i + 1 ? 'btn-primary' : 'btn-secondary'
                                                }`}
                                            >
                                                {i + 1}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {ID !== undefined && (
                <ViewModalUpdate setID={setID} id={ID} fetchUsers={fetchUsers} />
            )}
        </>
    );

    // Aquí siguen tus funciones handleSubmit, toggleBlockStatus, resetPassword, etc.

    function handleSubmit(id: any) {
        Swal.fire({
            position: 'center',
            icon: 'warning',
            title: 'Are you sure?',
            text: 'Once deleted, you will not be able to recover this User!',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
        }).then((result) => {
            if (result.isConfirmed) {
                const deleteUrl =
                    tenant === 0
                        ? `${API_URL}/v1/auth0/users/delete/${id}`
                        : `${API_URL}/v1/auth0/users/delete/${id}?tenantId=${tenant}`;

                axios.delete(deleteUrl).then(() => {
                    Swal.fire('Deleted!', 'Your User has been deleted.', 'success');
                    fetchUsers();
                });
            } else {
                Swal.fire({ title: 'Your User is safe!', icon: 'success' });
            }
        });
    }

    function toggleBlockStatus(userId: string, isBlocked: boolean) {
        Swal.fire({
            title: `Are you sure you want to ${isBlocked ? 'unblock' : 'block'} this user?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: `Yes, ${isBlocked ? 'unblock' : 'block'} it!`,
        }).then((result) => {
            if (result.isConfirmed) {
                axios
                    .put(`${API_URL}/v1/auth0/users/block`, {
                        userId,
                        block: !isBlocked,
                    })
                    .then(() => {
                        Swal.fire(`User ${isBlocked ? 'unblocked' : 'blocked'}!`, '', 'success');
                        setTimeout(fetchUsers, 500);
                    })
                    .catch((err) => {
                        Swal.fire(
                            'Error!',
                            `Failed to ${isBlocked ? 'unblock' : 'block'} user.`,
                            'error'
                        );
                        console.error(err);
                    });
            }
        });
    }

    function resetPassword(email: string) {
        Swal.fire({
            title: `Are you sure you want to reset the password for ${email}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, reset it!',
        }).then((result) => {
            if (result.isConfirmed) {
                axios
                    .post(
                        `${API_URL}/v1/auth0/users/reset-password${
                            tenant ? `?tenantId=${tenant}` : ''
                        }`,
                        { email }
                    )
                    .then(() => {
                        Swal.fire(
                            'Password Reset!',
                            'An email to reset the password has been sent.',
                            'success'
                        );
                    })
                    .catch((err) => {
                        Swal.fire('Error!', 'Failed to send password reset email.', 'error');
                        console.error(err);
                    });
            }
        });
    }

    function handleToggleMFA(orgId: string) {
        const newMFAStatus = !mfaActive;

        Swal.fire({
            title: `Are you sure you want to ${newMFAStatus ? 'enable' : 'disable'} MFA?`,
            text: `This action will ${newMFAStatus ? 'activate' : 'deactivate'} MFA for the organization.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: `Yes, ${newMFAStatus ? 'enable' : 'disable'} it!`,
        }).then((result) => {
            if (result.isConfirmed) {
                axios
                    .put(`${API_URL}/v1/auth0/users/mfa?orgId=${orgId}`, {
                        active: newMFAStatus ? true : null,
                    })
                    .then(() => {
                        Swal.fire(
                            'MFA Updated!',
                            `MFA has been ${newMFAStatus ? 'activated' : 'deactivated'} for the organization.`,
                            'success'
                        );
                        setMfaActive(newMFAStatus);
                    })
                    .catch((err) => {
                        Swal.fire('Error!', 'Failed to update MFA status.', 'error');
                        console.error(err);
                    });
            } else {
                Swal.fire('Cancelled', 'The MFA action was cancelled.', 'info');
            }
        });
    }

    function resetMFA(userId: string) {
        Swal.fire({
            title: 'Are you sure you want to reset MFA for this user?',
            text: 'This will clear the MFA settings for the user.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, reset it!',
        }).then((result) => {
            if (result.isConfirmed) {
                axios
                    .delete(`${API_URL}/v1/auth0/users/mfa-reset/${userId}`)
                    .then(() => {
                        Swal.fire(
                            'MFA Reset!',
                            'The MFA settings have been cleared for this user.',
                            'success'
                        );
                    })
                    .catch((err) => {
                        Swal.fire('Error!', 'Failed to reset MFA for this user.', 'error');
                        console.error(err);
                    });
            } else {
                Swal.fire('Cancelled', 'The MFA reset action was cancelled.', 'info');
            }
        });
    }
}

export default UsersCrud;
